export const SET_SOCKET_ID = 'setSocketId';
